export default "__VITE_ASSET__BzQJKS5P__"